module.exports = __webpack_public_path__ + "static/media/SFiOBOA_nn_primaerlogo_postale_neg.0e05217d.pdf";